export const STATUS_STYLE = {
  created: "text-slate-300 bg-white/5",
  pending_verification: "text-amber-300 bg-amber-500/10",
  approved: "text-emerald-300 bg-emerald-500/10",
  rejected: "text-red-300 bg-red-500/10",
  expired: "text-slate-500 bg-white/5",
};
export const STATUS_LABEL = {
  created: "Awaiting payment", pending_verification: "Verifying", approved: "Activated", rejected: "Rejected", expired: "Expired",
};

export const StatusPill = ({ status }) => (
  <span data-testid={`order-status-${status}`} className={`text-[10px] font-mono px-2 py-0.5 rounded ${STATUS_STYLE[status] || STATUS_STYLE.created}`}>{STATUS_LABEL[status] || status}</span>
);

export function OrderHistory({ orders, onResume }) {
  if (!orders.length) return null;
  return (
    <div data-testid="order-history" className="glass rounded-2xl overflow-hidden">
      <div className="p-4 border-b border-white/10 font-display font-semibold text-sm">Payment History</div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-[10px] font-mono uppercase text-slate-500 border-b border-white/10">
            <th className="text-left px-4 py-2">Order</th><th className="text-left px-4 py-2">Pack</th><th className="text-left px-4 py-2">Amount</th>
            <th className="text-left px-4 py-2 hidden sm:table-cell">UTR</th><th className="text-left px-4 py-2">Status</th><th className="px-4 py-2" />
          </tr></thead>
          <tbody>
            {orders.map((o, i) => (
              <tr key={o.order_id} data-testid={`order-row-${i}`} className="border-b border-white/5">
                <td className="px-4 py-2.5 font-mono text-xs text-purple-300">{o.order_id}</td>
                <td className="px-4 py-2.5">{o.pack_name}</td>
                <td className="px-4 py-2.5 font-mono">₹{o.amount.toLocaleString("en-IN")}</td>
                <td className="px-4 py-2.5 font-mono text-xs text-slate-400 hidden sm:table-cell">{o.utr || "—"}</td>
                <td className="px-4 py-2.5"><StatusPill status={o.status} />{o.status === "rejected" && o.reject_reason && <div className="text-[10px] text-red-400/80 mt-1">{o.reject_reason}</div>}</td>
                <td className="px-4 py-2.5 text-right">
                  {(o.status === "created" || o.status === "rejected") && (
                    <button data-testid={`order-resume-${i}`} onClick={() => onResume(o)} className="text-xs text-cyan-300 hover:underline">Resume</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
